var vskoCheckbox = angular.module('vskoCheckbox', []);

vskoCheckbox.directive('vskoCheckbox', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-checkbox.html'),
    transclude: true,
    required: ['ngModel'],
    scope: {
      label: '@',
      inline: '@',
      ngDisabled: '=',
      ngModel: '='
    }
  }
}]);

vskoCheckbox.directive('vskoCheckboxGroup', [function() {
  return {
    restrict: 'E',
    template: require('./vsko-checkbox-group.html'),
    transclude: {
      contentSlot: 'vskoCheckbox'
    }
  }
}]);
